<template lang="pug">
.success-content
  img(v-if='!hideIcon', src='/static/images/success-dj.png')
  p.title 提交成功
  p.success-content-tip
    span 工作人员会在48小时发货，若有疑问，请咨询
    span.onlineService-btn(@click='onlineServiceOpen') 在线客服
    span 或拔打服务热线 400-018-9011
  .submit-button(@click='close') 知道了
</template>

<script>
export default {
  props: {
    hideIcon: {
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    onlineServiceOpen() {
      window.onlineServiceOpen()
    },
  },
}
</script>

<style lang="less" scoped>
.success-content {
  background: white;
  padding: 93px 0 70px;
}
img {
  display: block;
  margin: 0 auto;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  line-height: 36px;
  text-align: center;
}
.success-content-tip {
  text-align: center;
  width: 388px;
  margin: 0 auto;
  margin-top: 21px;
  span {
    font-size: 16px;
    color: #999;
    line-height: 30px;
  }
  .onlineService-btn {
    cursor: pointer;
    color: #fe8828;
  }
}
.submit-button {
  width: 150px;
  height: 40px;
  background: #fe8828;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
  margin: 25px auto 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/Stu/receivingInformation/success.vue